export default "/images/disney.svg?7966a2def9d75fb84cde1e5a9d9a8c0d";